$ = require 'jquery'
Keyboard = require 'lib/keyboard'
PopOver = require 'views/lib/pop-over'
Util = require 'lib/util'
View = require 'view'

module.exports = class BoardsSidebarBoardsView extends View
  events:
    'mouseenter .sidebar-boards-list li': 'hoverItem'
    'mouseleave .sidebar-boards-list': 'deselectBoards'

  hoverItem: (e) ->
    $el = $(e.target).closest('li')
    Util.selectMenuItem($('.sidebar-boards-list'), 'li', $el)
    return

  deselectBoards: (e) ->
    $boardLists = $('.sidebar-boards-list li').removeClass('selected')
    return

  arrowKeyEvent: (e) ->
    key = Keyboard.getKey(e)
    Util.navMenuList($('.sidebar-boards-list'), 'li:visible', key)
    return

  enterKeyEvent: (e) ->
    $selected = $('.sidebar-boards-list li.selected:visible:first a')
    if $selected.length > 0
      $selected.click()
      PopOver.hide()
    return



// WEBPACK FOOTER //
// ./app/scripts/views/boards-sidebar/boards-sidebar-boards-view.coffee